<img *ngIf="data.insertType === 'IMAGE'" src="{{ url }}" />

<video *ngIf="data.insertType === 'VIDEO'" controls controlslist="nodownload">
  <source type="video/{{ data.insertExtension }}" src="{{ url }}" />
</video>
